export default __webpack_public_path__ + "static/media/Video_Default_Icon.81db53ed.svg";